import { styled } from '@mui/material/styles';

// Form/Screen className constants — passed as string props (formStyle / screenContainerStyle / screenContainer.props.className).
// Styles for these classes live on the AccountSettingsRoot wrapper below.
export const AS_FORM_STYLE = 'account-settings-form-style';
export const AS_SCREEN_WIDTH = 'account-settings-screen-width';
export const AS_SCREEN_CONTAINER = 'account-settings-screen-container';
export const AS_SCREEN_CONTAINER_MOBILE = 'account-settings-screen-container-mobile';
export const AS_ACCESS_CONTAINER = 'account-settings-access-container';
export const AS_FLEX_ROW_CLASS = 'account-settings-flex-row';

/** Top-level wrapper for the admin account-settings page; encapsulates descendant Form className styles. */
export const AccountSettingsRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),

  [`& .${AS_FORM_STYLE}`]: {
    alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: `${theme.breakpoints.values.lg}px !important`,
    overflow: 'visible !important',

    '& .inputEach': {
      alignItems: 'flex-start',

      '& .dropZone': {
        position: 'relative',
      },

      '& .dropZone .initialFiles': {
        '& .IMAGE': {
          maxHeight: '100%',
        },
        '&:hover': {
          borderColor: 'inherit !important',
        },
        height: 100,
        backgroundColor: theme.palette.action.disabled,
      },

      '& .dropZone > div:nth-of-type(2):not(.initialFiles)': {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 5,
        height: 100,
        minHeight: 100,

        '& div:first-of-type': {
          display: 'none',
        },

        '&:hover': {
          borderColor: 'black',
        },

        '& .MuiGrid-container': {
          position: 'absolute',
          top: 0,
          margin: 0,
          width: '100%',
          height: 90,

          '& .MuiGrid-item': {
            padding: 0,
            display: 'block',

            '& img': {
              height: 90,
            },
          },
        },

        '& > div p': {
          fontSize: 10,
        },
      },
    },
    '& .titleContainer': {
      marginBottom: 0,
    },
  },

  [`& .${AS_SCREEN_WIDTH}`]: {
    boxSizing: 'border-box',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl, .Mui-disabled': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },

  [`& .${AS_SCREEN_CONTAINER}`]: {
    maxWidth: 400,
    padding: `0 ${theme.spacing(3)}`,
  },

  [`& .${AS_SCREEN_CONTAINER_MOBILE}`]: {
    maxWidth: 'none !important',
  },

  [`& .${AS_ACCESS_CONTAINER}`]: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    width: 'auto !important',
    '& .MuiFilledInput-root.Mui-disabled.MuiInputBase-formControl': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl, .MuiFormControlLabel-label.Mui-disabled': {
      color: theme.palette.text.primary,
    },
  },

  [`& .${AS_FLEX_ROW_CLASS}`]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  maxWidth: theme.breakpoints.values.lg,
  margin: '0 auto 10px',
}));

export const FullWidth = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(1),
}));

export const LocRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontSize: 13,
  '& .account-settings-loc-icon': {
    marginRight: theme.spacing(1),
  },
}));

export const AS_LOC_ICON = 'account-settings-loc-icon';

export const BoxContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});
